import type { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { dutyStatusChangeRefs } from "../subjects/dutyStatusChange/refs";

/**
 * The driver signed out of a unit's ELD.
 */
export const logoutV1 = tmsEventKind(
  { category: "session", kind: "logout", version: 1 },
  { refs: dutyStatusChangeRefs, facts: {} },
);

export const LogoutV1Schema = logoutV1.schema;
export const LogoutV1FactsSchema = logoutV1.facts;

export type LogoutV1 = z.infer<typeof LogoutV1Schema>;
export type LogoutV1Facts = z.infer<typeof LogoutV1FactsSchema>;

/** Every version of `logout`, keyed by version. What `catalog.ts` places under `session`. */
export const logout = { 1: logoutV1 } as const;
